import React from 'react';
import osf from './osf.svg';

const IconOsf = () => (
  <div>
    <img src={osf} alt="osf" />
  </div>
);

export default IconOsf;
